import * as Yup from "yup";

export const validationHelper: any = {
  // name: Yup.string()
  //   .matches(/^[a-zA-Z]+$/, "Invalid name")
  //   .max(50, "Max. 50 latter valid")
  //   .min(2, "Min. 2 latter valid")
  //   .required(`${msg || "Name"} is required`),
  // required: (label: any) =>
  //   Yup.string().required(label ? `${label} required` : "Required"),
  required: (label: any) =>
    Yup.string()
      .required(label ? `${label} required` : "Required")
      .test('no-whitespace', label ? `${label} cannot be only spaces` : 'Cannot be only spaces', 
        (value) => !value || value.trim().length > 0
      ),
  // for arr-------------------------------------------------------------
  arr: (label: any) =>
    Yup.array()
      .min(1, "You can't leave this blank.")
      .required("You can't leave this blank.")
      .nullable(),

  // name : (label:any) => Yup.string().max(50,"Maximum 50 letters").min(2, "Min. 2 latter valid").matches(/^[a-zA-Z]+$/, "Invalid name").required(label ? `${label} required` : "Required"),
  name: (label: any) =>
       Yup.string()
         .max(50, "Maximum 50 letters")
         .min(2, "Min. 2 letters required")
         .matches(
          /^[A-Za-z\s]+$/,
           "Invalid name — only letters and spaces allowed" 
         )
         .required(label ? `${label} required` : "Required"),
      pincode: (label: any) =>
        Yup.string()
          .matches(/^[1-9][0-9]{5}$/, "Invalid pincode — must be exactly 6 digits")
          .required(label ? `${label} required` : "Required"),

  // commonText: (label: any) =>
  //   Yup.string()
  //     .max(50, "Maximum 50 letters")
  //     .required(label ? `${label} required` : "Required"),
  commonText: (label: any) =>
    Yup.string()
      .trim() // removes leading/trailing spaces
      .matches(/^(?!\s*$).+$/, "Only spaces are not allowed")
      .max(50, "Maximum 50 letters")
      .required(label ? `${label} required` : "Required"),
  commonOnlyText: (label: any) =>
    Yup.string()
      .max(50, "Maximum 50 letters")
      .matches(/^[A-Za-z]+( [A-Za-z]+)*$/, "Only Alphabet allows")
      .required(label ? `${label} required` : "Required"),
  commonNumber: (label: any) =>
    Yup.number()
      .positive("Must be positive numbers")
      .integer("Must be integer value")
      .min(0, "Should be greater than 0")
      .max(100000, "Too much value")
      .required(label ? `${label} required` : "Required"),
  tierDuration: (label: any) =>
    Yup.number()
      .positive("Must be positive numbers")
      .integer("Must be integer value")
      .min(0, "Should be greater than 0")
      .max(1000, "Max value 1000")
      .required(label ? `${label} required` : "Required"),
  Numberwithpoint: (label: any) =>
    Yup.number()
      .positive("Must be positive numbers")
      .moreThan(0, "Should be greater than 0")
      .max(100000, "Too much value")
      .required(label ? `${label} required` : "Required"),
      Numberwithpointwithzero: (label: any) =>
  Yup.number()
    .test(
      "non-negative",
      "Must be positive numbers or 0",
      (value:any) => value >= 0
    )
    .max(100000, "Too much value")
    .required(label ? `${label} required` : "Required"),
  commonDescription: (label: any) =>
    Yup.string()
      .max(500, "Maximum 500 letters")
      .required(label ? `${label} required` : "Required"),
  mobileNumber: (label: any) =>
    Yup.string()
      .min(10, "Must be 10 Digit")
      .max(10, "Must be 10 Digit")
      .matches(/^([6-9][0-9]{9})$/, "Invalid Entry")
      .required(label ? `${label} required` : "Required"),
  // emailAddress: (label:any) => Yup.string().email("Must be a valid email address").required(label ? `${label} required` : "Required"),
  // emailAddress: (label: any) =>
  //   Yup.string()
  //     .trim()
  //     .lowercase()
  //     .matches(
  //       /^[a-zA-Z0-9._%+-]+@gmail\.com$/,
  //       "Must be a valid Gmail address ending with @gmail.com"
  //     )
  //     .required(label ? `${label} is required` : "Email is required"),
  emailAddress: (label: any) =>
    Yup.string()
      .trim()
      .lowercase()
      .matches(
        /^[a-zA-Z0-9](\.?[a-zA-Z0-9_\-+])*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Must be a valid email address"
      )
      .email("Must be a valid email address")
      .required(label ? `${label} is required` : "Email is required"),
  gstin: Yup.string().matches(
    /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/,
    "Please enter a valid GST number"
  ),
  panNumber: Yup.string().matches(
    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    "Please enter a valid PAN number"
  ),
  aadharNumber: Yup.string().matches(
    /^[0-9]{12}$/,
    "Aadhaar number must be exactly 12 digits"
  ),
  password: (label: any) =>
    Yup.string()
      .required(label ? `${label} required` : "Required")
      .min(8, "Password is too short - minimum 8.")
      .max(50, "Maximum 50 letter")
      .matches(/[a-z]/, "Must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Must contain at least one uppercase letter")
      .matches(/[0-9]/, "Must contain at least one number")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Must contain at least one special character"
      ),
  // functioned validation with params
  confirmPassword: (ref: any, label: any) =>
    Yup.string()
      .oneOf([Yup.ref(ref)], "Passwords must match")
      .required(label ? `${label} required` : "Required"),

      commonPointMultiplier: (label: any) =>
  Yup.number()
    .min(0, "Value must be at least 0")
    .max(1, "Value must not exceed 1")
    .required(label ? `${label} required` : "Required"),
};
